import { NgModule } from '@angular/core';
import { TreatmentDefinitionModule } from './treatment-definition/treatmentDefinition.module';
import { TreatmentCommonModule } from './common/treatmentCommon.module';
import { TreatmentFeedbackModule } from './treatment-feedback/treatment-feedback.module';
import {TreatmentJourneyModule} from "./journey/treatmentJourney.module";


@NgModule({
    imports: [
        TreatmentCommonModule,
        TreatmentDefinitionModule,
        TreatmentFeedbackModule,
        TreatmentJourneyModule,
    ]
})
export class MedicalTreatmentModule { }
